"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CardPreview = /*#__PURE__*/function (_React$Component) {
  _inherits(CardPreview, _React$Component);

  function CardPreview() {
    _classCallCheck(this, CardPreview);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardPreview).apply(this, arguments));
  }

  _createClass(CardPreview, [{
    key: "_getImage",
    value: function _getImage(card) {
      var image = null;

      if (card.category === 'standard') {
        image = require('../../../assets/card.png');
      }

      if (card.status === 'inactive' || card.status === 'pending_activation') {
        image = require('../../../assets/activate_card.png');
      }

      return image;
    }
  }, {
    key: "render",
    value: function render() {
      var card = this.props.card;
      var pan = card.pan;
      var formatPan = pan.match(/.{1,4}/g);
      var newFormatPan = formatPan[0] + ' ' + formatPan[1] + ' ' + formatPan[2] + ' ' + formatPan[3];
      return _react["default"].createElement(_index.LPOverridable, {
        name: "card.preview",
        card: this.props.card
      }, _react["default"].createElement("div", {
        style: {
          position: 'relative',
          maxWidth: 500
        }
      }, _react["default"].createElement("img", {
        src: this._getImage(this.props.card),
        style: {
          width: '100%',
          height: 'auto'
        },
        alt: "card"
      }), card.status === 'active' || 'stolen' || 'locked' ? _react["default"].createElement("span", {
        className: "panNumber"
      }, newFormatPan) : null));
    }
  }]);

  return CardPreview;
}(_react["default"].Component);

exports["default"] = CardPreview;